// extracted by mini-css-extract-plugin
export default {"wikiPopularTags":"nyYnw","title":"Pfdv_","tagsWrapper":"NSiDY","tagItem":"ZuOJa"};